<h2 class="title">{{ partner?.name }}</h2>
@if (partner) {
<div class="partner-details">
  <div class="left-column">

    @if (offers.length > 0) {
    <div class="partner-offers-section">
      
      <div class="section">
        <h3>Aktualne oferty Partnera</h3>
        <div class="offers-list">
          @for (offer of offers; track offer) {
          <app-offer-view class="offer-item" [offer]="offer" (click)="goToOfferDetails(offer.id)"></app-offer-view>
          }
        </div>
      </div>
      
    </div>
    }
    
    @if (branches.length > 0) {
    <div class="partner-branches-section">
      <h3>Oddziały partnera</h3>
      <div class="branches-list">
        @for (partner of branches; track partner) {
        <app-partnerspartner-view (click)="goToPartnerDetails(partner.id, partner.name)" class="partner-item"
          [partner]="partner">
        </app-partnerspartner-view>
        }
      </div>
    </div>
    }



    @if (partnerProducts.length > 0) {
    <div class="section products">
      <h3>Program lojalnościowy</h3>
      <small>Zbieraj punkty i odbieraj nagrody. Informacje o programie znajdziesz w regulaminie promocji. Za nagrody i
        ich dystrybucję odpowiada partner programu.</small>
      @if (productsLoading) {
      <div class="products-loading">
        <mat-progress-spinner diameter="32"></mat-progress-spinner>
      </div>
      }
      @if (!productsLoading && partnerProducts.length > 0) {
      <div class="partner-products-list">
        @for (product of partnerProducts; track product) {
        <app-partner-product class="partner-product-item" [product]="product">
        </app-partner-product>
        }
      </div>
      }
    </div>
    }

    @if (isValidPosition(partner)) {
    <div class="map-container">
    <app-map-view [centerMap]="getPartnerMapCenter()" [zoomMap]="15" [pointerLocal]="getPartnerPointerLocal()">
    </app-map-view>
    </div>
    }


  </div>
  <div class="right-column">
     <h3>O Partnerze</h3>
    @if (partner.file) {
    <div class="partner-image">
      <img [src]="imagesUrl + '/' + partner.file" alt="Partner image"  />
    </div>
    }

    <div class="partner-description" [innerHTML]="partner.info"></div>

    @if (partner.contact || partner.url) {
    <div class="partner-contact-section">
      <h3>Dane kontaktowe</h3>
      @if (partner.contact) {
      <div class="partner-contact-items">
        <div [innerHTML]="partner.contact"></div>
      </div>
      }
    </div>
    }
    @if (partner.url) {
    <div class="partner-url">
      <mat-icon>language</mat-icon>
      <span>Jesteśmy również w internecie </span>
      <a [href]="partner.url" target="_blank" rel="noopener noreferrer">{{ partner.url }}</a>
    </div>
    }

    @if (campaignsLoading || currentCampaigns.length > 0) {
    <div class="current-campaigns-container">
      @if (campaignsLoading) {
      <mat-progress-spinner diameter="24"></mat-progress-spinner>
      }
      @if (false && !campaignsLoading) {
      <h3>Aktywne kampanie partnera</h3>
      @for (campaign of currentCampaigns; track campaign) {
      <div class="campaign-item">
        <span class="campaign-name">{{ campaign.name }}
          @if (campaign.description) {
          <button mat-button class="campaign-info-btn" (click)="openCampaignDescription(campaign)">
            <mat-icon>info</mat-icon> Więcej informacji
          </button>
          }
        </span>
        @if (campaign.point_per_transaction) {
        <span class="campaign-badge campaign-badge--score">
          <mat-icon>star</mat-icon> <strong>{{ campaign.point_per_transaction }} pkt / za każdą wydaną złotówkę
          </strong>
        </span>
        }
        @if (campaign.point_per_entry) {
        <span class="campaign-badge campaign-badge--entry">
          <mat-icon>how_to_reg</mat-icon> <strong>{{ campaign.point_per_entry }} pkt / za wejście</strong>
        </span>
        }
        @if (campaign.valid) {
        <span class="campaign-badge campaign-badge--valid">
          <mat-icon>event</mat-icon> Ważne do: <strong>{{ campaign.valid | date:'dd.MM.yyyy' }}</strong>
        </span>
        }
      </div>
      }
      }
      <small>Pamiętaj, że punkty są niezależnie naliczane dla każdego partnera plus za każdą tranakcję dostajsz
        punkty ZGranego Grona, które możesz wymieniać na nagrody. Informację o ilości uzbieranych punktów znajdziesz
        w swoim profilu w karcie "Twoje karty".</small>
    </div>
    }

    @if (personsLoading || getPersonsForPartner().length > 0) {
    <div class="person-points-conainer">
      @if (!personsLoading) {
      <h3>Punkty lojalnościowe Twoich mieszkańców</h3>
      @if (getPersonsForPartner().length === 0) {
      <div class="person-points-empty">
        Brak punktów dla tego partnera
      </div>
      }
      @for (person of getPersonsForPartner(); track person) {
      <div class="person-points-row">
        <span class="person-points-name">{{ person.name }} {{ person.surname }}</span>
        @if (getPartnerAggregation(person); as agg) {
        @if (agg.aggregation_score) {
        <span class="person-points-stat"><mat-icon>star</mat-icon>{{
          agg.aggregation_score }} pkt</span>
        }
        @if (agg.aggregation_amount) {
        <span class="person-points-stat"><mat-icon>payments</mat-icon>{{
          agg.aggregation_amount | number:'1.2-2' }} zł</span>
        }
        @if (agg.aggregation_transactions) {
        <span class="person-points-stat"><mat-icon>point_of_sale</mat-icon>{{
          agg.aggregation_transactions }}
          trans.</span>
        }
        @if (agg.aggregation_entries) {
        <span class="person-points-stat"><mat-icon>how_to_reg</mat-icon>{{
          agg.aggregation_entries }} wejść</span>
        }
        }
      </div>
      }
      }
      @if (personsLoading) {
      <mat-progress-spinner diameter="24"></mat-progress-spinner>
      }
    </div>
    }
  </div>

  
  
</div>
}